import React, { Component } from "react";
import { Segment, Icon, Button } from "semantic-ui-react";
import axios from "axios";
import ReactTable from "react-table";
import { prevButton, nextButton } from "components/shared/TablePagination";

import DownloadPricebookButton from "./DownloadPricebookButton";

class SystemsTable extends Component {
  state = {
    activeTier: null,
    dealerId: null,
    dealerName: "",
    tableData: [],
    loading: true,
    error: null,
    pages: null,
    activeFilter: 0,
    activeVarietyFilter: 0,
    tieredPricing: null,
    tiers: [],
    pricebookId: null,
  };

  table = React.createRef();

  componentDidMount = () => {
    axios.get(`/profile/`).then(({ data }) => {
      this.setState(
        {
          dealerId: data.id,
          dealerName: data.name,
          tieredPricing: data.tiered_pricing,
        },
        () => this.fetchTiers()
      );
    });
  };

  fetchTiers = () => {
    const req = {
      dealer_id: this.state.dealerId,
    };
    axios.post(`/dealer-pricing-tiers/`, req).then(({ data }) => {
      this.setState({
        tiers: data.pricebook_tier_links
          .sort((a, b) => (a.position > b.position ? 1 : -1))
          .map((t) => ({
            key: t.pricing_tier_id,
            position: t.position,
            text: t.tier_name,
            value: t.pricing_tier_id,
            id: t.pricing_tier_id,
          })),
      });
    });
  };

  onFilterButtonClick = (e, filter) => {
    e.preventDefault();
    const { activeFilter } = this.state;

    if (activeFilter !== filter) {
      this.setState({ activeFilter: filter });
      this.onFetchData(this.table.current.state, null, filter);
    }
  };

  onFetchData = (
    state,
    instance,
    activeFilter = this.state.activeFilter,
    activeVarietyFilter
  ) => {
    const { page, pageSize, sorted, filtered } = state;

    // if (!this.state.pricebookId) return this.setState({ loading: false });

    this.setState({ loading: true });

    filtered.forEach((filter) => {
      let filteredObject = "";

      switch (filter.id) {
        case "name":
          filteredObject = "brand";
          break;
        case "system_name":
          filteredObject = "self";
        default:
          break;
      }

      filter.object = filteredObject;
    });

    const req = {
      page: page * pageSize,
      page_size: pageSize,
      sorted,
      filtered,
      variety:
        activeVarietyFilter !== undefined
          ? activeVarietyFilter
          : this.state.activeVarietyFilter,
      status: activeFilter,
    };

    axios
      .post("/retrieve-dealer-systems/", req)
      .then(({ data }) => {
        let numPages = 0;

        if (data.total < pageSize) {
          numPages = 1;
        } else {
          numPages = Math.ceil(data.total / pageSize);
        }

        this.setState({
          tableData: data.data,
          pages: numPages,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  onVarietyFilterClick = (value) => {
    this.setState({
      activeVarietyFilter: value,
    });

    this.table.current.state.page = 0;

    this.onFetchData(
      this.table.current.state,
      null,
      this.state.activeFilter,
      value
    );
  };

  onTierChange = (e, d) => {
    this.setState({ activeTier: d.value }, () =>
      this.onFetchData(this.table.current.state, null)
    );
  };

  render() {
    const { tableData, loading, pages, tiers, tieredPricing } = this.state;

    let columns = [
      {
        Header: "Name",
        id: "system_name",
        accessor: (d) => `${d.name}${d.tier_name ? ` - ${d.tier_name}` : ""}`,
        filterable: false,
        sortable: false,
      },
    ];

    if (tieredPricing) {
      const tierGroup = {
        Header: "Tiers",
        columns: [],
      };

      tiers.forEach((tier) => {
        tierGroup.columns.push({
          Header: tier.text,
          id: `tier${tier.value}`,
          filterable: false,
          sortable: false,
          accessor: (d) => {
            const sys = d.systems.find((s) => s.pricing_tier_id === tier.id);

            if (!sys) return "-";
            if (sys.pricebook_price_in_pennies_formatted === "0.00") return "-";

            return <Icon name="check circle" color="green" />;

            // return (
            //   <span>
            //     <b>${sys.pricebook_price_in_pennies_formatted}</b>{" "}
            //     <span style={{ fontSize: ".85em" }}>
            //       Payout: ${sys.dealer_payout_in_pennies_formatted}
            //     </span>
            //   </span>
            // );
          },
        });
      });

      columns.push(tierGroup);
    } else {
      const defaultPricingTier = tiers.find((t) => t.position === 1);

      columns.push({
        // Header: `Customer's Cost`,
        Header: "Available",
        id: "price",
        filterable: false,
        sortable: false,
        accessor: (d) => {
          if (defaultPricingTier) {
            const sys = d.systems.find(
              (s) => s.pricing_tier_id === defaultPricingTier.value
            );

            if (!sys) return "-";

            return <Icon name="check circle" color="green" />;

            return `$${sys.pricebook_price_in_pennies_formatted}`;
          }

          return "-";
        },
      });

      // columns.push({
      //   Header: "Dealer Payout",
      //   id: "payout",
      //   filterable: false,
      //   sortable: false,
      //   accessor: (d) => {
      //     if (defaultPricingTier) {
      //       const sys = d.systems.find(
      //         (s) => s.pricing_tier_id === defaultPricingTier.value
      //       );

      //       if (!sys) return "-";

      //       return `$${sys.dealer_payout_in_pennies_formatted}`;
      //     }

      //     return "-";
      //   },
      // });
    }

    return (
      <Segment padded>
        <div>
          <div style={{ marginBottom: "20px" }}>
            <p style={{ margin: "0 0 10px 0", display: "block" }}>
              Filtering systems by...
            </p>
            {varietyFilters.map((b) => (
              <Button
                basic={
                  this.state.activeVarietyFilter === b.value ? false : true
                }
                color={b.color}
                content={b.text}
                onClick={(e) => this.onVarietyFilterClick(b.value)}
                key={b.value}
              />
            ))}
          </div>
          <ReactTable
            data={tableData}
            columns={columns}
            defaultPageSize={10}
            filterable
            minRows={5}
            className="-ui -striped -table"
            noDataText={`No Systems Available`}
            loadingText={`Loading Systems...`}
            loading={loading}
            rowsText={`Systems`}
            multisort={false}
            ref={this.table}
            manual
            pages={pages}
            onFetchData={this.onFetchData}
            PreviousComponent={prevButton}
            NextComponent={nextButton}
          />
        </div>
        <DownloadPricebookButton
          dealerId={this.state.dealerId}
          dealerName={this.state.dealerName}
        />
      </Segment>
    );
  }
}

export default SystemsTable;

const varietyFilters = [
  { value: 0, text: "Split", color: "blue" },
  { value: 1, text: "Package", color: "blue" },
  { value: 2, text: "Mini-Split", color: "blue" },
  { value: 4, text: "A la carte", color: "blue" },
];
